<div class="chat_bot" [ngClass]="{'opened': showChatbot==true, 'minimized': minimized == true}">
  <div class="chat-room-wrapper">
    <div class="chat-room">
      <div class="chat-header expandableCollapsibleDiv">
        <div class="header_logo">
          <img src="assets/chatbot/images/fab-btn2.gif" alt="FCI-Kisan Bandhu Image" class="me-3">
          <span class="screen-reader" *ngIf="toggleVal == 'English'">FCI Help Desk</span>
          <span class="screen-reader" *ngIf="toggleVal == 'Hindi'">FCI हेल्प डेस्क</span>
        </div>
        <button (click)="opensweetalert()" id="bot_close" class="fab-btn-close" title="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="chat-body" id="chat_room" [hidden]="minimized">

        <!-- <div class="select-language" style="padding:5px">
          <div class="form-check form-check-inline ">
            <input class="form-check-input" type="radio" value="English" id="inlineRadio1" [(ngModel)]="toggleVal"
              (change)="onValChange($event)">
            <label class="form-check-label" for="inlineRadio1">English</label>
          </div>
          <div class="form-check form-check-inline me-0">
            <input class="form-check-input" type="radio" value="Hindi" id="inlineRadio2" [(ngModel)]="toggleVal"
              (change)="onValChange($event)">
            <label class="form-check-label" for="inlineRadio2">हिंदी</label>
          </div>
        </div> -->

        <p class="today text-center screen-reader" *ngIf="toggleVal == 'English'"><b>Today, {{ today | date:'d MMM y' }}</b></p>
        <p class="today text-center screen-reader" *ngIf="toggleVal == 'Hindi'"><b>आज की तारीख, {{ today | date:'d MMM y' }}</b></p>

        <div>
          <div *ngFor="let item of botObj; let last = last; let i = index">
            <div class="chat-msg border-btn" [ngClass]="{'light-bg': item.actionType == 'btn'}">
              <div class="text-center mb-1  text-decoration" [ngClass]="item.msg?'customBox':''">

                <ng-container>
                  <span *ngIf="item.actionType == 'btn'" [innerHtml]="item.msg" class="gary-text screen-reader"></span>
                </ng-container>

                <ng-container>
                  <div *ngIf="item.actionType == 'faq'" [innerHtml]="item.msg" class="slideInLeft text-top screen-reader"></div>
                </ng-container>
                <ng-container><span *ngIf="item.actionType == 'selectSugg'" [innerHtml]="item.msg"
                    class="slideInLeft screen-reader"></span>
                  <ng-container><span *ngIf="item.actionType == 'viewAns'" [innerHtml]="item.msg"
                      class="slideInLeft screen-reader"></span>
                  </ng-container>
                  <ng-container><span *ngIf="item.actionType == 'longRes'" [innerHtml]="item.msg"
                      class="slideInLeft screen-reader"></span>
                  </ng-container>
                </ng-container>
              </div>

              <div class="btnBox" *ngIf="item.actionType == 'btn'">
                <button class="btn howdy-click screen-reader" *ngFor="let btn of item.btns" (click)="query(btn)">
                  <b>{{btn}}</b>
                </button>
              </div>

            </div>
            <div class="right" *ngIf="item.type == 'UR'">
              <div class="chat-msg screen-reader">
                {{item.msg}}
              </div>
            </div>
           
            <div>
              {{last ? scroll_ele() : ''}}
            </div>


            <div *ngIf="searchName.length > 0 && viewAns != 'viewAns'">
              <ul id="myUL" class="option-box">
                <ng-container *ngFor="let item of searchName">
                  <li class="screen-reader" (click)='searchData(item.msg,item.result)' *ngIf="item.msg!='NA_'"><a href="#">{{item.msg}}</a>
                  </li>
                  <div class="screen-reader" *ngIf="item.msg=='NA_'" style="text-align: center">
                    No suggestions available
                  </div>
                </ng-container>
              </ul>
            </div>

            <div *ngIf="item.actionType == 'viewSugg'">
              <div class="accordion" id="chartbot-accordion">
                <div class="accordion-item" *ngFor="let res of item.msg ;let index=index">
                  <span class="accordion-header" id="'heading'+index" (click)="click(index,this.tempSearchName)">
                    <a class="accordion-button screen-reader" [ngClass]="accrdReadStatus[index] == true?'':'collapsed'"
                      data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                      aria-controls="collapseTwo">
                      {{res.msg}}
                    </a>
                  </span>
                  <ng-container>
                    <div id="collapseTwo" class="accordion-collapse collapse "
                      [ngClass]="accrdReadStatus[index] == true?'show':''" aria-labelledby="'heading'+index"
                      data-bs-parent="#chartbot-accordion" *ngIf="accrdReadStatus[index] == true">
                      <div class="accordion-body">
                        <ng-container>
                          <span class="screen-reader" [innerHtml]="'Ans: ' + res.result"></span>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="chat-msg" *ngIf="typing==1">
          <img src="assets/chatbot/images/loading.gif" height="16px" alt="Fci-chatbot-loading">
        </div>
        <div class="btnBox" *ngIf="userMsg == 'btn'">
          <button class="btn howdy-click" (click)="query(botMsg.split('~')[1])">{{botMsg.split('~')[1]}}</button>
        </div>
      </div>
      <div class="chat-footer-container">

        <div class="chat-footer" #chatmessage [hidden]="minimized">
          <input class="screen-reader" [placeholder]="placeholder" #queryInput autofocus (keyup.enter)="entClicked($event)"
            (input)="keyupClicked($event)" (keyup.backSpace)="backspaceClicked()" type="{{inputType}}"
            [(ngModel)]="text">

          <button type="button" title="Send" (click)="sendClicked($event)" [disabled]="typing==1 || typing==2">
            
            <i class="bi bi-send-fill"></i>
          </button>
        </div>

      </div>

    </div>
  </div>

  <div *ngIf="!fabChatbtn" [ngClass]="toggleVal=='English'?'mayIHelp floatingimg screen-reader':'mayIHelp mayIHelpBlk floatingimg screen-reader'">{{ (toggleVal=='English') ? 'May I help you' : 'क्या मैं आपकी सहायता कर सकता हूं?' }} ?<span class="crossBtn"
      (click)="showChatbotBtn()">
      <i class="bi bi-x-lg"></i></span>
  </div>
  <button type="button" class="fab-btn screen-reader" id="fab_btn" title="Chat with FCI Bot" [ngClass]="{'opened': showChatbot==true}"
    (click)="chatbotshow($event);callBot()">
    <img src="assets/chatbot/images/fab-btn2.gif" alt="FCI-Kisan Bandhu Image">
  </button>

</div>